import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AuxiliaresModule } from '../../../auxiliares/auxiliares.module';
import { ReemplazoCategoriaDialogComponent } from './reemplazo-categoria-dialog.component';

/**
 * Dialogo de reemplazo de categoria, compartido entre el modulo de categorias (borrar una
 * categoria) y el de clientes (quitarsela a un cliente). Los dos casos piden lo mismo: a que
 * categoria pasan los vecinos que la tenian vigente.
 */
@NgModule({
  declarations: [ReemplazoCategoriaDialogComponent],
  imports: [CommonModule, AuxiliaresModule],
  exports: [ReemplazoCategoriaDialogComponent],
})
export class ReemplazoCategoriaSharedModule {}
